import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLOutputElement extends HTMLElement { constructor(tagName: string = 'OUTPUT', ownerDocument?: any) { super(tagName, ownerDocument); } }
